import type { BranchDay, BranchOpenNow } from "@workspace/api-client-react";

export const DAY_ORDER: BranchDay[] = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
export const DAY_LABELS: Record<BranchDay, string> = {
  mon: "Monday", tue: "Tuesday", wed: "Wednesday", thu: "Thursday",
  fri: "Friday", sat: "Saturday", sun: "Sunday",
};

/** "Open · closes 22:00", "Closed · opens 09:00 Tuesday", or null for unknown. Never prints undefined. */
export function formatOpenNow(openNow: BranchOpenNow | null | undefined): string | null {
  if (!openNow) return null;
  if (openNow.status === "open") {
    return openNow.closesAt ? `Open · closes ${openNow.closesAt}` : "Open";
  }
  if (openNow.status === "closed") {
    if (!openNow.opensAt) return "Closed";
    const day = openNow.opensDay ? ` ${DAY_LABELS[openNow.opensDay]}` : "";
    return `Closed · opens ${openNow.opensAt}${day}`;
  }
  return null;
}
